import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const TableSkeleton = ({ columns = 6, rows = 10 }) => {
  let baseColor = '#e2e8f0';
  let highlightColor = '#f1f5f9';

  return (
    <div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: '#335797' }}>
            {Array.from({ length: columns }).map((_, i) => (
              <th
                key={i}
                style={{
                  padding: '12px',
                  color: '#fff',
                  backgroundColor: '#335797',
                  border: 'none',
                  borderRadius: '0rem',
                }}
              >
                <Skeleton
                  height={8}
                  width={60}
                  baseColor={baseColor}
                  highlightColor={highlightColor}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <tr key={rowIdx} style={{ borderBottom: '1px solid #e2e8f0' }}>
              {Array.from({ length: columns }).map((_, colIdx) => (
                <td key={colIdx} style={{ padding: '12px', border: 'none', borderRadius: '0rem' }}>
                  <Skeleton
                    height={14}
                    width={80}
                    baseColor={baseColor}
                    highlightColor={highlightColor}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Fake pagination skeleton */}
      <div
        style={{
          borderTop: '1px solid #e2e8f0',
          backgroundColor: '#f8fafc',
          padding: '16px 20px',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px',
        }}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton
            key={i}
            height={32}
            width={32}
            borderRadius={6}
            baseColor={baseColor}
            highlightColor={highlightColor}
          />
        ))}
      </div>
    </div>
  );
};
